import React, { Component } from 'react'

import { Container } from 'components/Layout'
import Page from 'components/Page'
import PageHeader from 'components/Page/PageHeader'
import { Crumbs } from 'components/BreadCrumbs'
import CasesList from 'features/Cases/CasesList'

export default class Cases extends Component {
  render() {
    return (
      <Page layout={{ header: 'app' }} title="Support Cases">
        <PageHeader>
          <Crumbs title="Support Cases" />
        </PageHeader>
        <Container paddingTop paddingBottom>
          <CasesList />
        </Container>
      </Page>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Cases/Cases.jsx